import { cva } from 'class-variance-authority';
import { Text } from '@nula/core-ui';
import { ownerTag, type TemplateSummary } from '@/lib/templates/catalog';
import styles from './template-owner-tag.module.css';

interface TemplateOwnerTagProps {
  owner: TemplateSummary['owner'];
  /** Faint ink, for a row whose template can't run on this document. */
  dimmed?: boolean;
  className?: string;
}

const tag = cva(styles.tag, {
  variants: {
    nula: { true: styles.nula },
    dimmed: { true: styles.dimmed },
  },
});

export function TemplateOwnerTag({ owner, dimmed = false, className }: TemplateOwnerTagProps) {
  return (
    <Text className={tag({ nula: owner === 'nula', dimmed, className })}>{ownerTag(owner)}</Text>
  );
}
